/**
 * SteemWorld API Configuration
 *
 * Centralized configuration for all SteemWorld API endpoints.
 * Environment variables can override default values.
 */

export const STEEMWORLD_CONFIG = {
  /** Base URL for SteemWorld API */
  baseUrl: import.meta.env.VITE_STEEMWORLD_API_URL || 'https://sds.steemworld.org',

  /** API endpoint paths */
  endpoints: {
    feeds: '/feeds_api',
    followers: '/followers_api',
    notifications: '/notifications_api',
    contentSearch: '/content_search_api',
  },

  /** Default request parameters */
  defaults: {
    /** Default number of items per page */
    limit: 20,
    /** Default pagination offset */
    offset: 0,
    /** Default body preview length */
    bodyLength: 250,
    /** Request timeout in milliseconds */
    timeout: 30000,
  },
} as const

export type SteemWorldConfig = typeof STEEMWORLD_CONFIG
